import React from 'react';
import {
    Button,
    Checkbox,
    Form,
    Input,
    Select,
    InputNumber,
    Divider,
} from 'antd';

const City = () => {
    return (
        <Form.Item
            label="Miejscowość"
            name="city"
            rules={[
                {
                    required: true,
                    message: 'Proszę podać miejscowość',
                },
            ]}
        >
            <Input />
        </Form.Item>
    );
};

export default City;
